import React from 'react';
import { PanelType } from '../../fluent';
import { StandarPanel } from './StandarPanel';
import { CodeEditor } from './CodeEditor';
export class JavaScriptEditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: this.props.code || '',
            show: this.props.show || false,
            title: this.props.title || 'Editor JS'
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            code: nextProps.code,
            show: nextProps.show,
            title: nextProps.title || 'Editor JS',
        });
    }
    render() {
        return React.createElement(StandarPanel, { headerText: this.state.title + ' JS', isOpen: this.state.show, type: PanelType.large, onAccept: () => {
                this.props.onAccept(this.state.code);
                this.props.onClose();
            }, onClose: () => {
                this.props.onClose();
            }, onRender: () => React.createElement(CodeEditor, { value: this.state.code || '', onChanged: json => {
                    this.setState({
                        code: json
                    }, () => this.props.onChange(this.state.code));
                }, language: 'javascript' }) });
    }
}
